import React from 'react';
import { Banner, MessageStatus } from '@nexus/lib-react/dist/core/Banner/Banner';
import { useI18n } from '../../../../../i18n';
import Dac7InfoCard from '../Dac7InfoCard';
import S from './style/Dac7Layout';
import EyeHidden from '../assets/eye-hidden.svg';
import QuestionMark from '../assets/question-mark.svg';

interface Props {
  children: React.ReactNode;
  topBanner: JSX.Element;
}

const Dac7Layout = ({ children: dac7Form, topBanner }: Props) => {
  const i18n = useI18n();
  const handleOnClick = () => {
    window.open(i18n`dlv_dac7_mobile_url`, '_blank');
  };
  return (
    <S.LayoutContainer>
      {topBanner}
      <S.UpperLayer>
        <S.MobileHeadline mb={8}>{i18n`dlv_dac7_headline`}</S.MobileHeadline>
        <S.MobileDescription>
          {i18n`dlv_dac7_mobile_description`}
          <Banner
            mt={24}
            mb={24}
            icon={
              <S.Icon>
                <EyeHidden />
              </S.Icon>
            }
            type={MessageStatus.SUCCESS}
          >
            {' '}
            {i18n`dlv_dac7_privacy_note`}
          </Banner>
          <S.Link renderIcon={QuestionMark} onClick={handleOnClick}>
            {i18n`dlv_dac7_mobile_url_text`}
          </S.Link>
        </S.MobileDescription>
      </S.UpperLayer>
      <S.LowerLayer>
        <S.StartContainer>
          <S.DesktopHeadline mb={8}>{i18n`dlv_dac7_headline`}</S.DesktopHeadline>
          <S.DesktopDescription>
            {i18n`dlv_dac7_desktop_description`}
            <Banner
              mt={24}
              mb={24}
              icon={
                <S.Icon>
                  <EyeHidden />
                </S.Icon>
              }
              type={MessageStatus.SUCCESS}
            >
              {' '}
              {i18n`dlv_dac7_privacy_note`}
            </Banner>
          </S.DesktopDescription>
          {dac7Form}
        </S.StartContainer>
        <S.EndContainer>
          <Dac7InfoCard />
        </S.EndContainer>
      </S.LowerLayer>
    </S.LayoutContainer>
  );
};

export default Dac7Layout;
